import React, { Fragment } from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import TechnologiesRow from 'Components/Sections/TechWeBuildOnTiWin/TechnologiesRow'
import { Column, Row, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { TECH_WE_BUILD_ON_TI_WIN_ITEMS } from './constants'
import { DesktopContent, ItemDash, ItemHeader, MobileItem } from './styles'

type Props = PaddingProps

function TechWeBuildOnTiWinSection({ ...rest }: Props) {
  const { isMobile, isTablet } = useResponsiveLayout()

  const isNarrow = isMobile || isTablet

  return (
    <SectionWrapper {...rest}>
      <Column fullWidth gap={17}>
        <Text as="h2" mb={5} medium title title40>
          Tech We Build On to Win
        </Text>

        {isNarrow ? (
          <Column fullWidth gap={11}>
            {TECH_WE_BUILD_ON_TI_WIN_ITEMS.map(item => (
              <MobileItem
                gridTemplateColumns={['1fr', '1fr', '1fr', 'auto 1fr']}
                key={item.id}
              >
                <ItemDash />

                <Text as="h3" body20 medium nowrap title>
                  {item.title}
                </Text>

                {!isMobile && <div />}

                <TechnologiesRow data={item.technologies} />
              </MobileItem>
            ))}
          </Column>
        ) : (
          <DesktopContent>
            {TECH_WE_BUILD_ON_TI_WIN_ITEMS.map(item => (
              <Fragment key={item.id}>
                <ItemHeader
                  flexDirection={['column', 'column', 'row']}
                  height="56px"
                  key={item.id}
                >
                  <Row alignCenter gap={7}>
                    <ItemDash />

                    <Text as="h3" body20 medium nowrap title>
                      {item.title}
                    </Text>
                  </Row>
                </ItemHeader>

                <TechnologiesRow data={item.technologies} />
              </Fragment>
            ))}
          </DesktopContent>
        )}
      </Column>
    </SectionWrapper>
  )
}

export default TechWeBuildOnTiWinSection
